<section class="cart-overview-wrapper">
    <h1 class="heading-3">
        <i class="fa-solid fa-cart-shopping margin-right-8" aria-hidden="true"></i>{{'cart.overview.your_cart' | translate}}
        <span> ({{cart?.totalQuantity}} {{getItemsTotalQuantityTag(cart?.totalQuantity) | translate}})</span>
    </h1>
    <div class="cart-overview-container">
        <div class="flex-col-left">
            <div class="product-summary-container">
                <ng-container *ngTemplateOutlet="notifications"></ng-container>
                <div class="cart-product-summary">
                    <cart-product-summary *ngIf="cart?.products.length > 0; else emptyCart"></cart-product-summary>

                    <ng-template #emptyCart>
                        <div class="empty-cart">
                            <span class="margin-right-8" translate="cart.empty.cart.message"></span>
                            <a *ngIf="!nfrMhpShoppingOnly" [routerLink]="LANDING_ROUTE"
                               translate="cart.empty.cart.shop.now"></a>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="save-for-later-container" *ngIf="allowCartSaveForLater && saveForLaterProducts?.length >= 1">
                <h2 class="heading-3">
                    <i class="fa-solid fa-bookmark margin-top-8"></i> {{ 'cart.product.save.for.later.title' | translate }}<span> ({{ saveForLaterProducts.length }} {{getItemsTotalQuantityTag(saveForLaterProducts.length) | translate}})</span>
                </h2>
                <div class="product-summary-container">
                    <div class="cart-product-summary">
                        <cart-saved-product></cart-saved-product>
                    </div>
                </div>
            </div>
        </div>
        <div class="price-summary-container">
            <ng-container *ngTemplateOutlet="notifications"></ng-container>
            <div class="price-container">
                <div class="cart-price-summary">
                    <h3 class="heading-4">
                        {{ 'cart.overview.cart.summary' | translate }}
                    </h3>
                    <div class="subtotal-container">
                        <table>
                            <tr>
                                <td>{{'cart.order.total' | translate}}</td>
                                <td data-automation="cart.order.total.value">{{cart?.totalPrice | usanacurrency | async}}</td>
                            </tr>
                            <tr *ngIf="shouldDisplayVolume">
                                <td>{{'cart.order.total.volume' | translate }}</td>
                                <td data-automation="cart.order.total.volume.value">{{cart?.totalVolume}}</td>
                            </tr>
                            <ng-container *ngIf="!limitedShopping">
                                <tr>
                                    <td>{{'cart.order.totals.tax' | translate}}</td>
                                    <ng-container *ngTemplateOutlet="hideTotalsTemplate"></ng-container>
                                </tr>
                                <tr>
                                    <td>{{'cart.order.totals.shipping' | translate}}</td>
                                    <ng-container *ngTemplateOutlet="hideTotalsTemplate"></ng-container>
                                </tr>
                            </ng-container>
                        </table>
                    </div>

                    <ior *ngIf="allowIor && cart" [cart]="cart"></ior>
                    <ao-upsell></ao-upsell>

                    <button class="button button-large button-primary btn-spinner-outer"
                            [disabled]="!checkoutAvailable"
                            (click)="checkout()" data-automation="cartCheckoutButton">
                        <button-spinner [buttonTranslate]="'cart.checkout'" [isBusy]="checkoutButtonClicked"></button-spinner>
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #notifications>
    <div class="cart-notification-container">
        <div class="notification notification-alert" *ngIf="showWillCallOnlyMessage">
            <span translate="cart.order.will.call.only"></span>
            <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="hideWillCall = true;"></button>
        </div>
        <div class="notification" [ngClass]="freeShippingMessage.qualifyingThreshold? 'notification-success': 'notification-info'"
             *ngIf="!!freeShippingMessage && !hideFreeShippingMessage" [attr.data-automation]="freeShippingMessage.qualifyingThreshold ? 'cart.order.freeshipping.message.freeshippingachieved' : 'cart.order.freeshipping.message.amountawayfromfreeshipping'">
            {{freeShippingMessage.messageDisplay}}
            <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="hideFreeShippingMessage = true;"></button>
        </div>
        <div class="notification notification-alert" *ngIf="showRenewalFeeMessage">
            <customer-service [preText]="'cart.renewal.fee.added.to.cart'"></customer-service>
            <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="showRenewalFeeMessage = false;"></button>
        </div>
        <div class="notification notification-info" *ngIf="!!productCreditBalanceText && !hideProductCreditBalanceText">
            {{productCreditBalanceText}}
            <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="hideProductCreditBalanceText = true;"></button>
        </div>
    </div>
</ng-template>

<ng-template #hideTotalsTemplate>
    <td>----</td>
</ng-template>
